import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
} from '@lognai/synapse-design-system-v2';
import { ChangePasswordForm } from './ChangePasswordForm';

interface ChangePasswordModalProps {
  onClose: () => void;
}

/**
 * The account menu's Change Password dialog.
 *
 * It used to carry its own copy of the form, its own validation (min 6, against
 * Settings' min 8 and the server's real policy) and its own submit handling
 * (QA ledger AUTH-008, AUTH-009). It is now just the dialog around the shared
 * form.
 */
export function ChangePasswordModal({ onClose }: ChangePasswordModalProps) {
  const [done, setDone] = useState(false);

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
        </DialogHeader>

        <ChangePasswordForm
          idPrefix="account-menu"
          onSuccess={() => {
            setDone(true);
            // Long enough to read the confirmation, short enough not to trap.
            setTimeout(onClose, 2000);
          }}
          footer={({ canSubmit, isPending }) => (
            <DialogFooter>
              <Button type="button" variant="outline" onClick={onClose} disabled={isPending}>
                Cancel
              </Button>
              <Button type="submit" disabled={!canSubmit || isPending || done}>
                {isPending ? 'Changing…' : 'Change password'}
              </Button>
            </DialogFooter>
          )}
        />
      </DialogContent>
    </Dialog>
  );
}
